export default "__VITE_ASSET__Sk7niAAW__"